import React, { memo, useContext } from 'react'

import { Icon, ErrorOutlined } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import GenerateButton from 'Pods/ThreeDStudio/Shared/GenerateArea/Components/GenerateButton/GenerateButton'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import { capitalizeFirst } from 'Utils/capitalizeFirst'

import DetailRow from './Components/DetailRow/DetailRow'

function ErrorBannerState() {
  const t = useTranslation()
  const errorId = useThreeDStudioStore(state => state.generation.errorId)
  const errorDetails = useThreeDStudioStore(state => state.generation.errorDetails)
  const activeViewerSidebarTab = useThreeDStudioStore(state => state.ui?.activeViewerSidebarTab)
  const { showGenerationErrorDetails } = useContext(ThreeDStudioPageContext)
  const buttonLabel = t('viewer.errorBanner.tryAgain', {
    action: capitalizeFirst(activeViewerSidebarTab || 'generate'),
  })

  const { failureReason, failureMessage, providerErrorCode } = errorDetails || {}
  const hasErrorDetails = Boolean(failureReason || failureMessage || providerErrorCode)
  const shouldShowDetails = showGenerationErrorDetails && hasErrorDetails

  return (
    <div className="error-banner">
      <div className="error-banner__content">
        <div className="error-banner__icon-wrapper">
          <Icon
            svgComponent={ErrorOutlined}
            className="error-banner__icon"
            notSpaced
            withHover={false}
          />
        </div>
        <span className="cgt-heading-300 cgt-mb-12 error-banner__title">{t('viewer.errorBanner.title')}</span>
        <span className="error-banner__description">
          {t('viewer.errorBanner.description')}
        </span>
        {(errorId || shouldShowDetails) && (
          <div className="error-banner__error-wrapper">
            {errorId && (
              <DetailRow label={t('viewer.errorBanner.errorId')} pill>#{errorId}</DetailRow>
            )}
            {shouldShowDetails && (
              <>
                {failureReason && <DetailRow label={t('viewer.errorBanner.reason')}>{failureReason}</DetailRow>}
                {failureMessage && <DetailRow label={t('viewer.errorBanner.message')}>{failureMessage}</DetailRow>}
                {providerErrorCode && (
                  <DetailRow label={t('viewer.errorBanner.providerCode')}>{providerErrorCode}</DetailRow>
                )}
              </>
            )}
          </div>
        )}

        <div className="error-banner__actions">
          {/* TODO: Add report issue button */}
          {/* <Button type="secondary" size="small" customClass="error-banner__report-button">
            Report Issue
          </Button> */}
          <GenerateButton
            generateLabel={buttonLabel}
            generatedLabel={buttonLabel}
            generatingLabel={buttonLabel}
            withIcon={false}
          />
        </div>
      </div>
    </div>
  )
}

export default memo(ErrorBannerState)
